<template>
  <section-vue :class="classname">
    <div class="companies-logos__container container">
      <h3 class="companies-logos__headline">
        {{ $t("headline") }}
      </h3>

      <div class="companies-logos__logos">
        <div v-for="(logo, key) in $options.logos" :key="key" class="companies-logos__logo">
          <img
            class="companies-logos__logo-img"
            :class="`companies-logos__logo-img--${key}`"
            :src="logo"
            :alt="`${key} logo`"
          />
        </div>
      </div>
    </div>
  </section-vue>
</template>

<script>
import babbel from "@/pages/business/images/companies-logos/babbel.svg"
import booking from "@/pages/business/images/companies-logos/booking.svg"
import mhp from "@/pages/business/images/companies-logos/mhp.svg"
import tiktok from "@/pages/business/images/companies-logos/tiktok.svg"
import SectionVue from "@/shared/section"
import bemBlockModifiers from "@/utils/bem-block-modifiers"

const logos = {
  tiktok: tiktok,
  mhp: mhp,
  booking: booking,
  babbel: babbel
}

export default {
  name: "BusinessCompaniesLogos",
  components: {
    SectionVue
  },
  logos,
  props: {
    modifiers: { type: Array, default: () => [] }
  },
  computed: {
    classname() {
      return bemBlockModifiers("companies-logos", this.modifiers)
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "Join the 1,500+ organizations growing with Blinkist"
      },
      de: {
        headline: "Mehr als 1.500 Unternehmen vertrauen inzwischen auf Blinkist."
      }
    }
  }
}
</script>

<style lang="scss">
.companies-logos {
  $root: &;

  background-color: $pale-mint-grey;

  &__headline {
    margin-bottom: $spacing-48;

    text-align: center;
  }

  &__logos {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }

  &__logo {
    margin-bottom: $spacing-24;
  }

  &__logo-img {
    background-color: transparent;
  }

  @include media(max-width, m) {
    &__logo {
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  @include media(min-width, m) {
    &__logos {
      flex-direction: row;
    }

    &__logo {
      &:not(:last-child) {
        margin-right: $spacing-48;
      }
    }
  }
}
</style>
